/* eslint-disable no-undef, no-unused-vars */

import $ from 'jquery';
import '../../vendor/jquery.lazyload.min';
import '../../vendor/jquery.matchHeight-min';
import ga4 from '../ga4';

var isMobile = false;
var isMobileOS = false;

// https://gist.github.com/miohtama/1570295
// #!x&y=3 -> { x:null, y:3 }
function getHashParameters(url) {
  url = url || window.location.href;

  var vars = {};
  var hashes = url.slice(url.indexOf('#!') + 2).split('&');

  for(var i = 0; i < hashes.length; i++) {
    var hash = hashes[i].split('=');

    if(hash.length > 1) {
      vars[hash[0]] = hash[1];
    } else {
      vars[hash[0]] = null;
    }
  }

  return vars;
}

var performanceResize = function() {

  // BOF Performance

  var contentWidth = $(window).width() - ($(window).width() * 0.06);
  var containerWidth = (contentWidth + (contentWidth * 0.25));
  var sectionWidth = (contentWidth / 3);
  var activeSectionWidth = ((contentWidth / 3) + (contentWidth * 0.25));
  var activeSectionContentWidth = (contentWidth * 0.25);
  var activeSectionContentPadding = ($(window).width() * 0.03);
  var activeSectionPadding = (activeSectionContentPadding * 2) + activeSectionContentWidth;
  var performanceActiveSection = $('.performance .sections .section.active').length > 0 ? $('.performance .sections .section.active') : false;

  $('.performance .sections').css({
    width: containerWidth + 'px',
    left: 0
  });
  $('.performance .sections .section').css({
    width: sectionWidth + 'px'
  });
  $('.performance .sections .section').find('.content-holder').width(0);
  $('.performance .sections .section').find('.preview').css({
    left: 0
  });

  if(performanceActiveSection) {

    performanceActiveSection.css({
      'width': activeSectionWidth + 'px'
    });

    if(performanceActiveSection.is('.performance .sections .section:last')) {

      $('.performance .sections').css({
        'left': '-' + activeSectionContentWidth + 'px'
      });

      performanceActiveSection.find('.content-holder').css({
        width: (activeSectionContentWidth + activeSectionContentPadding) + 'px',
        left: '0px'
      });
      performanceActiveSection.find('.content').css({
        width: activeSectionContentWidth + 'px'
      });
      performanceActiveSection.css({
        width: activeSectionWidth + 'px'
      });
      performanceActiveSection.find('.preview').css({
        'left': (sectionWidth - activeSectionContentPadding) + 'px'
      });

    } else {

      performanceActiveSection.find('.content-holder').css({
        width: (activeSectionContentWidth + activeSectionContentPadding) + 'px',
        left: (sectionWidth - activeSectionContentPadding) + 'px'
      });
      performanceActiveSection.find('.content').css({
        width: activeSectionContentWidth + 'px'
      });

    }

  }

  // EOF Performance

};

$(document).ready(function() {

  if(navigator.appName === 'Microsoft Internet Explorer' || !!(navigator.userAgent.match(/Trident/) || navigator.userAgent.match(/rv:11/)) || (typeof $.browser !== 'undefined' && $.browser.msie === 1)) {
    $('html').addClass('isIE');
    $('p img').each(function() {
      var src = $(this).attr('src');
      var elementClass = $(this).attr('class');
      $(this).parent().html('<img class="' + elementClass + '" src="' + src + '"/>');
    });
  }

  if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || $(window).width() <= 768)
  {isMobile = true;}

  if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))
  {isMobileOS = true;}

  function skipLazyLoad() {
    var skipLazyloadElements = document.querySelectorAll('.lazyload,.lazyloadNoEffect');
    for(var i = 0; i < skipLazyloadElements.length; i++) {
      skipLazyloadElements[i].style.backgroundImage = 'url(' + skipLazyloadElements[i].dataset.original + ')';
    }
  }

  $(window).on('resize', function() {
    if(window.innerWidth > 768) {
      skipLazyLoad();
    }
  });

  $('.matchHeight').matchHeight();

  if(window.innerWidth > 768) {
    $('.lazyload').lazyload({
      effect: 'fadeIn',
      effectspeed: 200,
      load: function() {
        $(this).removeClass('lazyload');
      }
    });

    $('.lazyloadNoEffect').lazyload({
      load: function() {
        $(this).removeClass('lazyloadNoEffect');
      }
    });
  } else {
    skipLazyLoad();
  }

  if($('.car-card-contact-form .form-error').length) {
    $('.car-card-contact-form').show();
    $('html, body').animate({
      scrollTop: $('.car-card-contact-form').offset().top
    }, 1000);
    $('.form-error .error-text').addClass('show');
  }

  if(!$('.car-card-contact-form .form-error').length && $('.form-error').length) {
    $('html, body').animate({
      scrollTop: $('.form-error').offset().top
    }, 1000);
    $('.form-error .error-text').addClass('show');
  }

  function getCoords(elem) { // crossbrowser version
    var box = elem.getBoundingClientRect();

    var body = document.body;
    var docEl = document.documentElement;

    var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
    var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;

    var clientTop = docEl.clientTop || body.clientTop || 0;
    var clientLeft = docEl.clientLeft || body.clientLeft || 0;

    var top = box.top + scrollTop - clientTop;
    var left = box.left + scrollLeft - clientLeft;

    return {
      top: Math.round(top),
      left: Math.round(left)
    };
  }

  function indicateScroll(element) {
    if(element.length && $(window).width() < 1000) {
      window.addEventListener('scroll', function() {
        var scrollWidth = element[0].scrollWidth;
        element.children('.contentBlocker').parent().css('position', 'relative');
        if(!element.hasClass('scrollIndicated') && $(window).scrollTop() + 200 > getCoords(element[0]).top) {
          element.animate({
            scrollLeft: 80
          }, 300, 'swing', function() {
            element.animate({
              scrollLeft: 0
            }, 300, 'swing');
          });
          element.addClass('scrollIndicated');
        }
      });
    }
  }

  indicateScroll($('.collapsable-persons'));
  indicateScroll($('.services.mobile-scroll'));

  $('svg').parent().contents().filter(function() {
    return (this.nodeType === 3);
  }).remove();

  performanceResize();


  var hero3Animation = $('');
  $('.hero-3-column').on('mouseenter', function() {
    $(hero3Animation).stop();
    var backgroundElement = $(this).siblings('.hero-3-background');
    var backgroundUrl = $(this).attr('data-background');

    hero3Animation = $(backgroundElement).fadeTo(100, 0.0, function() {
      //$(backgroundElement).css('background-image', 0);
      if(backgroundUrl) {
        //console.log('there is background', backgroundUrl);
        $(backgroundElement).css('background-image', 'url(' + backgroundUrl + ')');
        hero3Animation = $(backgroundElement).fadeTo('300', 1);
      }
    });



  });

  $('.collapsable-header').on('click', function(event) {
    if($(this).is('a')) {
      $(this).find('.collapsable-header-plus').toggleClass('active');
      $(this).find('.collapsable-header-minus').toggleClass('active');
      $(this).parents('.collapsable-content').find('.collapsable-content-container').slideToggle(200);
      event.preventDefault();

      const text = $(this).find('.collapsable-header-text').text();
      ga4.sendEvent({ name: 'car_click_info_tab', params: {
        'click_text': text
      }})
    }
  });

  $('.search-filter-criteria-text').click(function() {
    $(this).siblings('.search-filter-criteria-container').slideToggle(200);
  });

  // New cars filter that appears in mobile devices only
  // Filtering a table under it - hiding all columns excepting selected one
  $('.cars-new-select').on('change', function() {
    var carGroup = $(this).val();
    if(carGroup) {
      var carGroupSelector = `[data-model-type="${carGroup}"]`;
      $('[data-model-type]').addClass('d-none');
      $('[data-model-type]').filter(carGroupSelector).removeClass('d-none');
    }
  });


  // Size of the window changes = ipad might changed its orientation
  // If new cars filter is not visible -> showing whole table of cars again
  $(window).on('resize', carFilterLoad);
  carFilterLoad();

  function carFilterLoad() {
    if($('.cars-new-select').is(':not(:visible)')) {
      // Triggering a change event to rebuild filters
      $('[data-model-type]').removeClass('d-none');
      $('.cars-new-select').val('');
      $('.cars-new-select').change();
    }
  }


  // Hover handler for images of new cars table
  var carsColHoverTimeout = 100;
  var carsColMouseEnterTimeout;
  $('.cars-col').on('mouseenter click', function() {

    resetCarHover(this);

    clearTimeout(carsColMouseEnterTimeout);
    var _this = this;
    carsColMouseEnterTimeout = setTimeout(function() {
      $(_this).addClass('hover');
      $(_this).find('.cars-description-more').fadeIn();
    }, carsColHoverTimeout);

  });

  $('.cars-car').on('mouseleave', resetCarHover);

  $(window).on('resize', resetCarHover);

  // Removing hovers from New cars in some cases
  function resetCarHover(excludeElement) {
    if(typeof excludeElement === 'undefined') {
      excludeElement = $();
    }

    $('.cars-col').not(excludeElement).each(function() {
      $(this).removeClass('hover');
      $(this).find('.cars-description-more').stop();
      $(this).find('.cars-car').stop();
      $(this).find('.cars-description-more').hide();
    });
  }

  if($('.collapse-buttons-container').length) {
    carCardButtonFixed();
    $(window).scroll(function() {
      carCardButtonFixed();
    });
  }

  function carCardButtonFixed() {
    var winPos = $(window).scrollTop();
    var btnPos = $('.collapse-buttons-container').offset().top;
    if(winPos >= btnPos) {
      $('.collapse-buttons').addClass('fixed');
      $('.collapse-buttons.container').addClass('fixed');
    } else {
      $('.collapse-buttons').removeClass('fixed');
      $('.collapse-buttons.container').removeClass('fixed');
    }
  }

  // Load next press-releases
  $(document).on('click', '.btn-load-next', function(event) {
    var url = $(this).attr('href');
    var appendToSelector = $(this).attr('data-append-to');
    var button = this;
    $.get(url, function(data) {
      //console.log('appending data', $(data).find(appendToSelector).html());
      $(button).remove();
      $(appendToSelector).append($(data).find(appendToSelector).html());
    });
    event.preventDefault();
  });

  // Test drive handlers
  $('.book-test-drive').on('click', function(event) {
    var carId = $(this).attr('data-car-id');
    scrollToBookTestDrive(carId);
    event.preventDefault();
  });

  var hashParameters = getHashParameters();
  var testCarId = hashParameters['test-drive'];
  scrollToBookTestDrive(testCarId);

  function scrollToBookTestDrive(carId) {
    if(carId) {
      var optionSelector = 'option[value=' + carId + ']';
      var formsContainingCarId = $(optionSelector).parents('form');
      if(formsContainingCarId.length) {
        var formContainingCarId = formsContainingCarId[0];
        $(formContainingCarId).find(optionSelector).attr('selected', 'selected').change();
        $('html, body').animate({
          scrollTop: $(formContainingCarId).offset().top
        }, 1000);
        event.preventDefault();
      }
    }
  }

  // End of test drive handlers

  // Disable 360 view for 300ms while scrolling
  var allow360view;

  function checkScroll360() {
    allow360view = setTimeout(function() {
      $('.car-image .disable360').hide();
    }, 300);
  }
  $(window).scroll(function() {
    clearTimeout(allow360view);
    $('.car-image .disable360').show();
    checkScroll360();
  });


  // Branch opening times collapse
  $('.current-status-container').click(function() {
    var $self = $(this);
    $self.parent().siblings('.all-opening-hours').slideToggle(200).toggleClass('open');
    $self.toggleClass('open');
  });

  $(document).on('click', '.services-next-page .btn', function(event) {
    var requestUrl = $(this).attr('href');

    $.get(requestUrl, function(data) {
      $('.services .services-next-page').remove();
      var parsedData = $('<div>').append($.parseHTML(data));
      $('.services .services-row').append($(parsedData).find('.services .services-row').html());
      $('.services .services-row').after($(parsedData).find('.services  .services-next-page'));
      initializeLiftupVideos();
      $(parsedData).remove();
    }).done(function() {
      $('.lazyloadNoEffect').lazyload({
        load: function() {
          $(this).removeClass('lazyloadNoEffect');
        }
      });
      $('.matchHeight').matchHeight();
    });

    event.preventDefault();
  });

  function initializeLiftupVideos() {
    $('.services .services-row video').each(function() {
      this.controls = true;
      videojs(this);
    });
  }

  initializeLiftupVideos();

  $(document).on('click', '.services-video-link', function(event) {
    var interactiveContent = $(this).parents('.services-interactive-content');
    var playButton = $(interactiveContent).find('.services-right-arrow');

    if($(playButton).is(':visible')) {
      var video = $(interactiveContent).find('video');
      var videoElement = video[0];
      videoElement.play();
      $(playButton).hide();
    }

    event.preventDefault();
  });

  $(document).on('click', '#sendFinancialCalculation', function(e) {

    const $form = $('#financeCalculatorForm');
    const url = '/stage-ajax/getToken';
    const $tokenInput = $form.find('input[name="stage_token"]');

    if($tokenInput.length) {
      $.ajax({
        method: 'GET',
        dataType: 'json',
        url: url
      }).done(function(res) {
        if(res.status === 'success' && res.token) {
          const stageToken = res.token;
          $tokenInput.val(stageToken);
          $form.attr('action', '?'); //send form to same page.
          $form.submit();
        } else {
          console.log('failed to get token');
        }
      }).fail(function(e) {
        console.log('failed to get token');
      });
    }
  });

});

export default {};
